function formatBytes(bytes, decimals = 2) {
  // converte número para bytes
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
function maxTextLength(text, maxLength) {
  if (text) {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }
}

function isValidURL(string) {
  //verifica se o URL é válido
  // eslint-disable-next-line no-useless-escape
  if(!string){
    return false
  }
  var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  return res;
}

function trimFileName(filename, limit = 5, spacer = '.') {
  //limita o nome de um arquivo
  const split = filename.indexOf('.');
  const name = filename.substring(0, split);
  const ext = filename.substring(split);

  let trimName = name.substring(0, limit);

  if (name.length > trimName.length) {
    trimName = trimName.padEnd(limit + 3, spacer);
  }

  return trimName + ext;
}
function linkify(text) {
  /*eslint no-useless-escape: "off"*/
  var urlRegex =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
  return typeof text === "string"
    ? text.replace(urlRegex, function (url) {
      let href = url;
      if (url.indexOf("https://") === -1 && url.indexOf("http://") === -1) {
        href = "https://" + url;
      }
      return (
        '<a href="' + href + '" target="_blank" rel="noopener noreferrer" >' +  url + "</a>"
      );
    })
    : text;
}
function replaceMentionValues(text) {
  let m;
  let matches = [];
  const regex = /((.)\[([^[]*)]\(([^(^)]*)\))/gim;
  while ((m = regex.exec(text)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    m.forEach(match => {
      if (!match.includes('@')) {
        matches.push(match);
      }
    });
  }
  return matches;
}
function formatedMentionsToHtml(text, userId, hightlightColor="#51A6FF"){ 
  let originalText = text;
  var matches = text ? text.match(/((.)\[([^[]*)]\(([^(^)]*)\))/gim) : null;
  if (matches) {
    matches.forEach(match => {
      const userInfo = replaceMentionValues(match);
      if (userInfo[1] === userId) {
        originalText = originalText.replace(match, '<mark style="color:'+hightlightColor+'; background: transparent;">@você</mark>');
      } else {
        originalText = originalText.replace(match, '<mark style="color:'+hightlightColor+';background: transparent;">@'+userInfo[0]+'</mark>');
      }
    });
  } 
  return originalText;
}
function formatedMentions(text, userId){
  let originalText = text;
  var matches = text ? text.match(/((.)\[([^[]*)]\(([^(^)]*)\))/gim) : null;
  if (matches) {
    matches.forEach(match => {
      const userInfo = replaceMentionValues(match); 
      if (userInfo[1] === userId) {
        originalText = originalText.replace(match, "@você");
      } else {
        originalText = originalText.replace(match, `@${userInfo[0]}`);
      }
    });
  } 
  return originalText;
}
function formatedTextReplaceMention(text){
  const regex = /[[\]]|(\(([^(^)]*)\))/g
  let aux = text.replace(regex, '');
  return aux.replace('@', ' @').replace(/(\r\n|\n|\r)/gm, '');
}
export {formatBytes, maxTextLength, isValidURL, trimFileName, formatedMentionsToHtml, formatedMentions, linkify, replaceMentionValues,formatedTextReplaceMention };
